module.exports = __webpack_public_path__ + "static/media/Sa 2.594433e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/Sa 2.mp3
// module id = 80
// module chunks = 0